export { default } from './Airplane'
